module.exports = __webpack_public_path__ + "img/about_us_hero_mobile.50bc42b8.webp";